import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';


const MapContainer = (props: any) => {
    const getMapOptions = (maps: any) => {
        return {
          mapTypeControl: true,
          streetViewControl: true,
          styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'on' }] }],
        };
      };
    
        const [center, setCenter] = useState({lat: 14.14713, lng: 79.85321 });
        const [zoom, setZoom] = useState(18);
        return (
            <div style={{ height: '100vh', width: '100%' }} id="map-section">
            <GoogleMapReact
              bootstrapURLKeys={{ key: 'AIzaSyCrAthLz1cZny5BHM09IPBkoWsQarxy6VM' }}
              defaultCenter={center}
              defaultZoom={zoom}
              options={getMapOptions}
            >
              <Marker
                lat={14.14713}
                lng={79.85321}
                name="CHALO Restro"
                color="#0071a8"
              />
            </GoogleMapReact>
          </div>
        );
    }

export default MapContainer;